// extracted by mini-css-extract-plugin
export default {"colorShuttleGrey":"#5C6770","unit":"8px","inputBox":"Qn4VbSXbOcXbs8VkvUxv","label":"Lwke1gHRLvKVSy4o1E2w"};